import React from 'react'
import { Text, Button, csx } from '@vtex/admin-ui'

import { useIntl } from '@/checkout-instore-legacy/hooks/intl'
import BaseModal from './BaseModal'

export type DialogResult = 'add-attachments' | 'skip-attachments'

interface DecisionDialogProps {
  isOpen?: boolean
  handleResult?: (result: DialogResult) => void
  onClose?: () => void
}

export const DecisionDialog = (props: DecisionDialogProps) => {
  const { isOpen, onClose, handleResult, ...rest } = props

  const intl = useIntl()

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage({ id: 'attachments.modal.dialog.title' })}
      {...rest}
    >
      <div
        className={csx({
          marginY: '$space-4',
          paddingX: '$space-6',
          '> *': {
            display: 'block',
            textAlign: 'center',
          },
        })}
        data-testid="attachments-decision-dialog-content"
      >
        <Text
          variant="action2"
          className={csx({
            marginBottom: '$space-6',
          })}
        >
          {intl.formatMessage({ id: 'attachments.modal.dialog.subtitle' })}
        </Text>
        <Button
          type="button"
          size="large"
          onClick={() => {
            handleResult?.('add-attachments')
          }}
          className={csx({
            width: '100%',
            height: '3rem',
            marginTop: '$space-4',
          })}
          data-testid="attachments-decision-dialog-custom-button"
        >
          {intl.formatMessage({ id: 'attachments.modal.dialog.custom-button' })}
        </Button>
        <Button
          type="button"
          size="large"
          variant="tertiary"
          onClick={() => {
            handleResult?.('skip-attachments')
          }}
          className={csx({
            width: '100%',
            height: '3rem',
            marginTop: '$space-4',
          })}
          data-testid="attachments-decision-dialog-skip-button"
        >
          {intl.formatMessage({ id: 'attachments.modal.dialog.skip-button' })}
        </Button>
      </div>
    </BaseModal>
  )
}
